__turbopack_context__.v({
  "read-next-card-badge": "ReadNextCard-module___VxJhG__read-next-card-badge",
  "read-next-card-body": "ReadNextCard-module___VxJhG__read-next-card-body",
  "read-next-card-container": "ReadNextCard-module___VxJhG__read-next-card-container",
  "read-next-card-cta": "ReadNextCard-module___VxJhG__read-next-card-cta",
  "read-next-card-eyebrow": "ReadNextCard-module___VxJhG__read-next-card-eyebrow",
  "read-next-card-eyebrow-dot": "ReadNextCard-module___VxJhG__read-next-card-eyebrow-dot",
  "read-next-card-link": "ReadNextCard-module___VxJhG__read-next-card-link",
  "read-next-card-logo": "ReadNextCard-module___VxJhG__read-next-card-logo",
  "read-next-card-logo-chip": "ReadNextCard-module___VxJhG__read-next-card-logo-chip",
  "read-next-card-teaser": "ReadNextCard-module___VxJhG__read-next-card-teaser",
  "read-next-card-time": "ReadNextCard-module___VxJhG__read-next-card-time",
  "read-next-card-title": "ReadNextCard-module___VxJhG__read-next-card-title",
});
